<template>
  <div>
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <!-- <h5 class="mb-5">Request Fund Form</h5> -->
            <div class="mb-3">
              <label>Maintenance Type <span class="text-danger">*</span></label>
              <div>
                <b-form-select
                  class="form-select rounded-0 rounded-start shadow-none w-100"
                  v-model="eload.maintenanceType"
                  :options="maintenanceTypeOptions"
                  :disabled="disableDropdown"
                >
                </b-form-select>
                <p class="small text-danger mb-0" v-if="!$v.eload.maintenanceType.required && submitted">Maintenance type is required</p>
              </div>
            </div>
            <div class="mb-3" v-if="eload.maintenanceType=='provider'">
              <label>Provider</label>
              <multiselect
                class="form-control p-0"
                v-model="eload.provider"
                placeholder="Select Provider"
                label="value"
                track-by="value"
                :options="providerOptions"
                :multiple="true"
                :allow-empty="true"
                :preselect-first="false"
                :disabled="disableDropdown"
              >
            </multiselect>
              <!-- <p class="small text-danger mb-0" v-if="!$v.eload.provider.required && submitted">Choose atleast 1 provider</p> -->
          </div>

           <div class="mb-3" v-if="eload.maintenanceType=='network'">
              <label>Network</label>
                <multiselect
                  class="form-control p-0"
                  v-model="eload.network"
                  placeholder="Select Network Name"
                  label="value"
                  track-by="value"
                  :options="networkOptions"
                  :multiple="true"
                  :allow-empty="true"
                  :preselect-first="false"
                  :disabled="disableDropdown"
                >
                </multiselect>
                <!-- <p class="small text-danger mb-0" v-if="!$v.eload.network.required && submitted">Choose atleast 1 network</p> -->
          </div>

            <!--<div class="mb-3" v-if="eload.maintenanceType=='network'">
              <label>Network Group</label>
              <div>
                <multiselect
                  class="form-control p-0"
                  v-model="eload.networkGroup"
                  placeholder="Select Network Group Name"
                  label="value"
                  track-by="value"
                  :options="networkGroupOptions"
                  :multiple="true"
                  :allow-empty="true"
                  :preselect-first="false"
                  :internal-search="false"
                  :disabled="disableDropdown"
                >
                </multiselect> -->
                <!-- <p class="small text-danger mb-0" v-if="!$v.eload.networkGroup.required && submitted">Choose atleast 1 network group</p> -->
           <!--   </div>
            </div> -->

            <div class="mb-3 row">
              <div class="col-12 col-md-6">
                <label>Maintenance Start Date & Time <span class="text-danger">*</span></label>
                <flat-pickr
                  v-if="this.$route.params.id==0"
                  v-model="eload.startDate"
                  :config="dateConfig"
                  placeholder="Start Date"
                  class="form-control"
                  :class="{ 'invalid-multiselect': !$v.eload.startDate.required && submitted }"
                  @input="validateDate()"
                ></flat-pickr>
                <flat-pickr
                v-if="this.$route.params.id>0"
                  v-model="eload.startDate"
                  :config="dateConfig2"
                  placeholder="Start Date"
                  class="form-control"
                  :class="{ 'invalid-multiselect': !$v.eload.startDate.required && submitted }"
                  @input="validateDate()"
                  :disabled="(eload.status=='Scheduled') ? false: true"
                ></flat-pickr>
                <p class="small text-danger mb-0" v-if="!$v.eload.startDate.required && submitted">Start date is required</p>
              </div>

              <div class="col-12 col-md-6">
                <label>Maintenance End Date & Time <span class="text-danger">*</span></label>
                <flat-pickr
                  v-if="this.$route.params.id==0 || eload.status=='Scheduled'"
                  v-model="eload.endDate"
                  :config="dateConfig"
                  placeholder="End Date"
                  class="form-control"
                  :class="{ 'invalid-multiselect': !$v.eload.endDate.required && submitted }"
                  @input="validateDate()"
                ></flat-pickr>
                <flat-pickr
                  v-if="eload.status=='Ended' || eload.status=='Cancelled' || eload.status=='Force Cancelled' || eload.status=='Ongoing'"
                  v-model="eload.endDate"
                  :config="dateConfig2"
                  placeholder="End Date"
                  class="form-control"
                  :class="{ 'invalid-multiselect': !$v.eload.endDate.required && submitted }"
                  @input="validateDate()"
                  :disabled="true"
                ></flat-pickr>
                <p class="small text-danger mb-0" v-if="!$v.eload.endDate.required && submitted">End date is required</p>
                <p class="small text-danger mb-0" v-else-if="!isDateRangeValid">End date should be ahead Start date</p>
              </div>
            </div>
            <div class="mb-3 row">
              <div class="col-md-12 mb-3">
                <label>Remarks <span class="text-danger">*</span></label>
                <b-form-textarea
                  v-model="eload.remarks"
                  placeholder="Enter remarks..."
                  rows="3"
                  max-rows="6"
                  :disabled="(eload.status=='Ended' || eload.status=='Cancelled' || eload.status=='Force Cancelled' || eload.status=='Ongoing') ? true : false"
                  :class="{'is-invalid': submitted && $v.eload.remarks.$error}">
                </b-form-textarea>
                <div v-if="submitted && !$v.eload.remarks.required" class="invalid-feedback">
                  Remarks is required.
                </div>
              </div>
            </div>

            <div class="d-flex align-items-center" v-if="this.$route.params.id>0">
              <label class="mb-0 me-2">Status: <span :class="{
                  'text-scheduled': eload.status == 'Scheduled',
                  'text-success': eload.status == 'Ongoing',
                  'text-ended': eload.status == 'Ended',
                  'text-danger': eload.status == 'Cancelled' || eload.status == 'Force Cancelled'
                }">{{eload.status}}</span></label>
              <!--<div class="form-check form-switch form-switch-md align-middle">
                <input type="checkbox" class="form-check-input" v-model="eload.status" />
              </div>-->
            </div>

            <div class="d-flex align-items-center mt-5">
              <!--<div class="d-flex align-items-center" v-if="$route.params.id > 0">
                <p class="mb-0 me-2 fw-semibold">Change Log:</p>
                <b-link href="#" @click="onModalOpen">View</b-link>
              </div>-->
              <b-button v-if="eload.status=='Ongoing' || eload.status=='Scheduled'" variant="light" class="w-sm" type="button" style="width: 170px" @click="cancelSchedule()">{{(eload.status=='Scheduled') ? 'Cancelled' : 'Force Cancelled' }}</b-button>
              <div class="ms-auto">
                <button v-if="eload.status=='Scheduled' || $route.params.id ==0" class="btn btn-primary me-3" style="width: 170px" @click="saveMaintenance()">{{ ($route.params.id >0) ? 'Update' : 'Save' }}</button>
                <router-link :to="{ name: 'E-Load Core Maintenance' }" class="tc-white">
                  <b-button variant="light" class="w-sm" type="button" style="width: 170px">Cancel</b-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { layoutMethods, erpFixMessages, coreEloadMaintenanceMethods, coreEloadDropdownComputed, coreEloadDropdownMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  page: {
    title: "Eload Maintenance Form",
  },
  validations: {
    eload: {
      startDate: { required },
      endDate: { required },
      maintenanceType: { required },
      remarks: { required }
    },
  },
  data() {
    return {
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30],
      filter: null,
      filterOn: [],
      orderBy: "id",
      sort: "DESC",
      sortDesc: false,
      submitted: false,
      isSearching: false,
      eload: {
        provider: "",
        network: "",
        networkGroup: "",
        startDate: "",
        endDate: "",
        status: "",
        maintenanceType: "",
        remarks: ""
      },
      search: {
        dateRange: "",
      },
      isDateRangeValid: true,
      isMainFieldEmpty: false,
      dateConfig: {
        allowInput: true,
        enableTime: true,
        minDate: "today",
        dateFormat: "Y-m-d H:i",
      },
      dateConfig2: {
        allowInput: true,
        enableTime: true,
        dateFormat: "Y-m-d H:i",
      },
      disableDropdown: false,
      disableDatePicker: false,
      showLogsModal: false,
      fields: [
        { key: "updated_at", label: "Date Modified", sortable: true },
        { key: "updated_by", label: "Modified By", sortable: true },
        { key: "prev_start_date", label: "Previous Start Date & Time", sortable: true },
        { key: "prev_end_date", label: "Previous End Date & Time", sortable: true },
        { key: "new_start_date", label: "New Start Date & Time", sortable: true },
        { key: "new_end_date", label: "New End Date & Time", sortable: true },
      ],
      flatpickrCtr: 0,
      maintenanceTypeOptions: [
        { text: "Select Maintenance Type", value: "" },
        { text: "System", value: "system" },
        { text: "Provider", value: "provider" },
        { text: "Network", value: "network" }
      ]
    };
  },
  components: {
    flatPickr,
    Multiselect,
  },
  computed: {
    ...erpFixMessages,
    ...coreEloadDropdownComputed,
    providerOptions() {
      return this.getCoreProvidersList.map((item) => {
        return {
          id: item.id,
          value: item.name,
        };
      });
    },
    networkOptions() {
      return this.getCoreNetworksList.map((item) => {
        return {
          id: item.id,
          value: item.name,
        };
      });
    },
  },
  methods: {
    ...layoutMethods,
    ...coreEloadMaintenanceMethods,
    ...coreEloadDropdownMethods,
    async saveMaintenance() {
      this.submitted = true;
      this.$v.$touch();
      this.isMainFieldEmpty = this.eload.provider == "" && this.eload.network == "";
      let maintenanceType = this.eload.maintenanceType
      if(maintenanceType!='system' && maintenanceType){
        let message1 = 'Provider is empty.',
            message2 = 'Please select atleast 1 Provider to proceed.'
            
        if(maintenanceType=='network') {
            message1 = 'Network is empty.',
            message2 = 'Please select atleast 1 Network to proceed.'
        }   
        if (this.isMainFieldEmpty) {
          Swal.fire(
            message1,
            message2,
            "warning"
          );
        }
      }

      if (((this.isMainFieldEmpty || this.$v.$invalid || !this.isDateRangeValid) && maintenanceType!='system') || this.eload.remarks=="") {
        return;
      }
      let scheduleStatus = 'active'
      let payload = {
        provider: this.eload.provider,
        network: this.eload.network,
        maintenanceType: maintenanceType,
        startDate: moment(this.eload.startDate).utc(),
        endDate: moment(this.eload.endDate).utc(),
        //active: this.eload.status ? 1 : 0,
        id: this.$route.params.id,
        scheduleStatus: scheduleStatus,
        updateStatus: false,
        remarks: this.eload.remarks,
      };
      
      if (this.$route.params.id > 0) {
        let response = await this.actionCoreEloadMaintenanceAPIPOST({
          params: payload,
          action: 'update-maintenance'
        })
        if(response.status == 'ok'){
          Swal.fire("Successfully Updated", `Maintenance ${maintenanceType} schedule has been successfully updated`, "success").then((swalRes) => {
              if (swalRes.isConfirmed) {
                this.$router.push({ name: "E-Load Core Maintenance" });
              }
            });
        }
      } else {
        let response = await this.actionCoreEloadMaintenanceAPIPOST({
          params: payload,
          action: 'save-maintenance'
        })
        if(response.status == 'ok'){
          Swal.fire("Successfully Created", `Maintenance ${maintenanceType} schedule has been saved`, "success").then((swalRes) => {
              if (swalRes.isConfirmed) {
                this.$router.push({ name: "E-Load Core Maintenance" });
              }
            });
        }
      }
    },
    async cancelSchedule() {
      let scheduleStatus = '', messageTitle = '', messageText = ''
      if(this.eload.status=='Scheduled'){
        scheduleStatus = 'cancelled'
        messageTitle = 'Cancel Maintenance'
        messageText = 'Are you sure you want to cancel this scheduled maintenance? This action will stop the maintenance before it begins.'
      }
      if(this.eload.status=='Ongoing'){
        scheduleStatus = 'force-cancelled'
        messageTitle = 'Force Cancel Maintenance'
        messageText = 'Are you sure you want to force cancel this maintenance? Any ongoing processes will be stopped immediately.'
      }  
      Swal.fire({
              title: messageTitle,
              text: messageText,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes",
              cancelButtonText: 'No'
          }).then( async(result) => {
            if(result.isConfirmed) {
              let payload = {
                updateStatus: true,
                id: this.$route.params.id,
                scheduleStatus: scheduleStatus
              };
              let response = await this.actionCoreEloadMaintenanceAPIPOST({
                params: payload,
                action: 'update-maintenance'
              })
              if(response.status == 'ok'){
                Swal.fire("Maintenance Cancelled", "The scheduled maintenance has benn successfully cancelled.", "success").then((swalRes) => {
                    if (swalRes.isConfirmed) {
                      this.$router.push({ name: "E-Load Core Maintenance" });
                    }
                  });
              }
            } else {
              return;
            }
          })
    },
    async validateDate() {
      if (this.eload.startDate && this.eload.endDate) {
        this.isDateRangeValid = moment(this.eload.startDate).isBefore(moment(this.eload.endDate));
      }
    },

    async getMaintenanceLogs() {
      let params = {
        maintenanceId: this.$route.params.id,
        page: this.isSearching ? 1 : this.currentPage,
        rows: this.perPage,
        sort: this.sort,
        orderBy: this.orderBy,
        search: this.search,
      };

      await this.getEloadMaintenanceLogs(params).then(() => {
        this.isSearching = false;
        this.showLogsModal = true;
      });
    },

    async sortList(action) {
      this.orderBy = action.sortBy;
      this.sort = action.sortDesc ? "DESC" : "ASC";
      await this.getMaintenanceLogs();
    },

    onModalOpen() {
      this.search.dateRange = "";
      this.getMaintenanceLogs();
    }
  },

  async mounted() {
    this.changeTitle({ title: "Eload Maintenance Schedule" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: 'E-Load Core Manager', to: { name: 'E-Load Core Maintenance'} },
        { text: "E-Load Maintenance Form", to: { name: "" } },
      ],
    });
    await this.fetchCoreNetworksList();
    await this.fetchCoreProvidersList();
    if (this.$route.params.id > 0) {
      let response = await this.actionCoreEloadMaintenanceAPIPOST({
        params: {
          search: {
            field: "id",
            keyword: this.$route.params.id,
          },
        },
        action: 'list-maintenance'
      })
      if(response.status == 'ok'){
        this.eloadMaintenanceList = response.message.rows;
        this.disableDropdown = true;
        this.eload.maintenanceType = this.eloadMaintenanceList[0].type
        this.eload.status = this.eloadMaintenanceList[0].status
        this.eload.provider = this.eloadMaintenanceList[0].provider ? this.eloadMaintenanceList[0].provider.split(",").map((providerId) => {
          return this.providerOptions.find((i) => i.value == providerId);
        }) : "";
        this.eload.network = this.eloadMaintenanceList[0].network ? this.eloadMaintenanceList[0].network.split(",").map((networkName) => {
          return this.networkOptions.find((i) => i.value == networkName);
        }) : "";

        this.eload.startDate = moment(this.eloadMaintenanceList[0].start_at).format("YYYY-MM-DD HH:mm");
        this.eload.endDate = moment(this.eloadMaintenanceList[0].end_at).format("YYYY-MM-DD HH:mm");
        this.dateConfig.minDate = moment(this.eloadMaintenanceList[0].start_date).format("YYYY-MM-DD HH:mm");
        this.eload.remarks = this.eloadMaintenanceList[0].remarks
      }
    }
  },
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

a.disabled {
  pointer-events: none;
}

.personal-details-widget {
  background-color: #e6eaf1;
}

.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invalid-multiselect {
  border: 1px solid #f34e4e;
}
.text-ended {
  color: #AFAFAF;
}
.text-scheduled {
  color: #4D56FF;
}
</style>
